import { render, staticRenderFns } from "./AppSmartTable.vue?vue&type=template&id=35ae5244"
import script from "./AppSmartTable.vue?vue&type=script&lang=js"
export * from "./AppSmartTable.vue?vue&type=script&lang=js"
import style0 from "./AppSmartTable.vue?vue&type=style&index=0&id=35ae5244&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports